(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;
  var key = 'mk_cookie_consent';
  var existing = localStorage.getItem(key);
  if (!existing) banner.hidden = false;

  function saveConsent(value) {
    localStorage.setItem(key, JSON.stringify({
      value: value,
      savedAt: new Date().toISOString()
    }));
    banner.hidden = true;
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-cookie-accept]')) saveConsent({ necessary: true, analytics: true, marketing: true });
    if (event.target.closest('[data-cookie-reject]')) saveConsent({ necessary: true, analytics: false, marketing: false });
    if (event.target.closest('[data-cookie-details-toggle]')) {
      var details = banner.querySelector('[data-cookie-details]');
      var save = banner.querySelector('[data-cookie-save]');
      if (details) details.hidden = false;
      if (save) save.hidden = false;
    }
    if (event.target.closest('[data-cookie-save]')) {
      saveConsent({
        necessary: true,
        analytics: !!banner.querySelector('[data-cookie-analytics]:checked'),
        marketing: !!banner.querySelector('[data-cookie-marketing]:checked')
      });
    }
    if (event.target.closest('[data-cookie-reset]')) {
      localStorage.removeItem(key);
      window.location.reload();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', function(event) {
  var thumb = event.target.closest('[data-full]');
  if (thumb) {
    var section = thumb.closest('[data-product-section]');
    var main = section && section.querySelector('.mk-product-gallery__image');
    if (main) {
      main.src = thumb.getAttribute('data-full');
      main.alt = thumb.getAttribute('data-alt') || main.alt;
      section.querySelectorAll('.mk-product-gallery__thumb').forEach(function(item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');
    }
  }

  var plus = event.target.closest('[data-qty-plus]');
  var minus = event.target.closest('[data-qty-minus]');
  if (plus || minus) {
    var form = event.target.closest('form');
    var input = form && form.querySelector('[data-qty-input]');
    if (!input) return;
    var value = parseInt(input.value || '1', 10);
    input.value = Math.max(1, value + (plus ? 1 : -1));
  }
});

document.addEventListener('change', function(event) {
  var input = event.target.closest('[data-variant-price]');
  if (!input) return;
  var section = input.closest('[data-product-section]');
  if (!section) return;
  section.querySelectorAll('[data-product-price], [data-submit-price]').forEach(function(node) {
    node.textContent = input.getAttribute('data-variant-price');
  });
});

  } catch(e) { console.error(e); }
})();
})();
